module.exports = __webpack_public_path__ + "static/img/cg.6b499fd5.png";